import styled from 'styled-components';
import { Box } from 'reflexbox';

export const Pointer = styled(Box)`
  cursor: pointer;
`;
